import React from 'react';
import ReactDOM from 'react-dom/client';

import './styles/global.css';
import './styles/responsive.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Suppress recharts warnings
console.warn = (() => {
  const warn = console.warn;
  return (...args) => {
    if (args[0]?.includes?.('width') && args[0]?.includes?.('height')) return;
    warn(...args);
  };
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // ✅ FIX: StrictMode hataya — yeh interceptors ko 2 baar register karta tha
  // jisse login pe error aate hi page reload ho jaata tha
  <App />
);

reportWebVitals();